module.exports = __webpack_public_path__ + "static/img/item-4-1-big.e22f8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-4-1-big.png
// module id = sZiX
// module chunks = 2